import React from 'react';

/**
 * Button — primary call-to-action. Yellow "solid" for the single most
 * important action; "outline" and "ghost" for secondary moves.
 * Sharp, confident, with a press-spring.
 */
export function Button({
  children,
  variant = 'solid',
  size = 'md',
  iconLeft = null,
  iconRight = null,
  disabled = false,
  as = 'button',
  ...rest
}) {
  const sizes = {
    sm: { padding: '0.5rem 0.9rem', font: 'var(--text-sm)', gap: '0.4rem' },
    md: { padding: '0.7rem 1.35rem', font: 'var(--text-base)', gap: '0.5rem' },
    lg: { padding: '0.95rem 1.9rem', font: 'var(--text-md)', gap: '0.6rem' },
  };
  const s = sizes[size] || sizes.md;

  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: s.gap,
    padding: s.padding,
    fontFamily: 'var(--font-display)',
    fontSize: s.font,
    fontWeight: 'var(--weight-semibold)',
    letterSpacing: 'var(--tracking-tight)',
    lineHeight: 1,
    borderRadius: 'var(--radius-pill)',
    border: 'var(--border-hairline) solid transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.45 : 1,
    transition: 'var(--t-hover)',
    whiteSpace: 'nowrap',
    userSelect: 'none',
  };

  const variants = {
    solid: { background: 'var(--accent)', color: 'var(--accent-contrast)', boxShadow: 'var(--glow-sm)' },
    outline: { background: 'transparent', color: 'var(--text-primary)', borderColor: 'var(--border-default)' },
    ghost: { background: 'transparent', color: 'var(--text-secondary)' },
  };

  const Tag = as;
  return (
    <Tag
      style={{ ...base, ...(variants[variant] || variants.solid) }}
      disabled={as === 'button' ? disabled : undefined}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = 'scale(0.96)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        if (variant === 'solid' && !disabled) e.currentTarget.style.boxShadow = 'var(--glow-sm)';
        if (variant === 'outline') e.currentTarget.style.borderColor = 'var(--border-default)';
        if (variant === 'ghost') e.currentTarget.style.color = 'var(--text-secondary)';
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        if (variant === 'solid') { e.currentTarget.style.background = 'var(--accent-hover)'; e.currentTarget.style.boxShadow = 'var(--glow-md)'; }
        if (variant === 'outline') { e.currentTarget.style.borderColor = 'var(--border-accent)'; e.currentTarget.style.color = 'var(--text-accent)'; }
        if (variant === 'ghost') { e.currentTarget.style.color = 'var(--text-primary)'; }
      }}
      onMouseOut={(e) => { if (variant === 'solid' && !disabled) e.currentTarget.style.background = 'var(--accent)'; }}
      {...rest}
    >
      {iconLeft}
      {children}
      {iconRight}
    </Tag>
  );
}

export default Button;
